import { render, staticRenderFns } from "./ReqAddRemoveModal.vue?vue&type=template&id=1f7af825&scoped=true"
import script from "./ReqAddRemoveModal.vue?vue&type=script&lang=js"
export * from "./ReqAddRemoveModal.vue?vue&type=script&lang=js"
import style0 from "./ReqAddRemoveModal.vue?vue&type=style&index=0&id=1f7af825&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7af825",
  null
  
)

export default component.exports